module.exports = __webpack_public_path__ + "static/media/logo-loader.20bdde8d.png";